<!-- 多礼包的活动页面 -->
<template>
  <div class="wrap qw_recall_maintain">
    <div class="error_page" v-if="errorCode">
      <div class="error_page_content" v-if="errorCode === 1306">
        请点击一下首条消息底部的见面惊喜，再参与此活动。
        如果您未找到见面惊喜，可【点我头像-联系客服】进行人工咨询
        <img style="width: 100%; margin-top: 12px;" src="https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/1303-guide.jpeg" alt="">
      </div>
      <div class="error_page_content" v-if="errorCode === 1319">
        一份见面礼仅限一个微信领取，请您用首次点击该见面礼的微信账号进行领取。
        如您有其他疑问，请【点我头像-人工客服】进行咨询
      </div>
    </div>
    <van-pull-refresh
      v-else
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="visible || disabledPull || activityInfo.activityStatus !== 0"
      @refresh="onRefresh"
    >
      <div class="header fs_15 color_white">
        <div class="d_flex account mb_15">
          <div class="role_name color_white mr_2 van-ellipsis">角色名：{{ roleInfo.roleName }}</div>
          <div class="role_bind account_btn text_nowrap header_btn" @click="onClickChangeBind">切换角色</div>
        </div>
        <div class="flex_between mb_15">
          <div class="time van-ellipsis">活动时间：{{ actTime }}</div>
          <div class="header_btn" @click="onShowRule">活动规则</div>
        </div>
        <div class="flex_between">
          <div style="color: #F0AB50">请在活动期间完成任务并领取惊喜</div>
          <div class="record_btn header_btn" @click="onShowRecord">领取记录</div>
        </div>
      </div>
      <div class="main mt_8">
        <div class="error_end color_white full-size flex_center" v-if="activityInfo.activityStatus === 1">
          活动已结束！
        </div>
        <div v-else class="blocks">
          <div class="block_item relative" v-for="item in blockInfo" :key="item.sectorId">
            <div class="block_title bg_cover text_center" style="background-image: url('https://assets.hzwxbz2.cn/box/platform_box_minigame_activity/img/block_header.png');">
              <div class="block_title_main fs_15 mb_4 van-ellipsis" style="color: #F3CC7B">{{ item.title }}</div>
              <div class="block_title_sub fs_12 color_white van-ellipsis">{{ item.subTitle }}</div>
            </div>
            <div class="block_reward_wrap">
              <div class="block_reward">
                <div class="block_reward_item flex_a_c" v-for="reward in item.slaveVoList" :key="reward.id">
                  <div class="block_reward_icon bg_contain mr_6" :style="{ backgroundImage: `url(${reward.giftIcon})` }"></div>
                  <div class="block_reward_info">
                    <div class="block_reward_name mb_4 van-ellipsis">{{ reward.giftName }}</div>
                    <div class="block_reward_condition mb_1 van-multi-ellipsis--l2">{{ reward.drawCondition }}</div>
                    <div class="block_reward_content van-multi-ellipsis--l2">{{ reward.giftContent }}</div>
                  </div>
                  <div
                    class="block_reward_btn flex_center color_white round_1000"
                    :class="{ 'btn_disabled': reward.drawStatus !== 0 }"
                    @click="onReceive(reward, item)"
                  >{{ reward.drawStatus === 0 ? '领取' : '已领取' }}</div>
                </div>
              </div>
            </div>
            <div class="block_btn"></div>
          </div>
        </div>
      </div>
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        :skins="{
          headerBg: '#ED804B'
        }"
        :innerTitleStyle="{color: '#ED804B'}"
        confirmButtonColor="#FF9C47"
        cancelButtonColor="#00BFD3"
        :before-close="onBeforeClose"
        @confirm="feedback.onSure"
      >
        <template v-if="feedbackType === FEEDTYPE_MAP.SWITCH_ROLE">
          <CustomSelect
            :modelValue.sync="selectedRoleId"
            label="选择角色"
            :options="roleList"
          />
          <div class="tip_content fs_12 mt_4 pl_6" style="color: #D62828">
            {{ !selectedRoleId && showTip ? '请选择角色' : '' }}
          </div>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.CONDITION_NOT_SATISFY">
          <div class="receive_fail">
            <p class="receive_fail_title" style="font-size: 15px; line-height: 18px;" v-html="errorMsg"></p>
            <div class="receive_fail_content flex_a_c mt_12">
              <div class="receive_fail_icon bg_contain" :style="{ backgroundImage: `url(${curGift.giftIcon})` }"></div>
              <div class="receive_fail_info">
                <div class="receive_fail_name mb_4">{{ curGift.giftName }}</div>
                <div class="receive_fail_desc fs_12 van-multi-ellipsis--l2">{{ curGift.giftContent }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="feedbackType === FEEDTYPE_MAP.SUCCESS">
          <div class="receive_success">
            <div class="receive_s_item">
              <div class="receive_s_item_label mb_6 bold mr_8 van-ellipsis" style="font-size: 15px;">{{ curGift.giftName }}：</div>
              <div class="receive_s_item_value">
                <div v-clipboard="cdk" class="receive_s_item_success">
                  <div class="receive_s_item_cdk">{{ cdk }}</div>
                  <div class="receive_s_item_btn">
                    <i class="iconfont yw-copy"></i>复制
                  </div>
                </div>
              </div>
              <div class="receive_s_item_content flex_a_c mt_14 mb_32" style="font-size: 15px;">
                <div class="receive_s_item_content_label text_nowrap">惊喜内容：</div>
                <div class="receive_s_item_content_value">{{ curGift.giftContent }}</div>
              </div>
            </div>
            <div class="highlight fs_12 text_center" style="color: #D62828">惊喜时间有限，请及时前往游戏中兑换</div>
          </div>
        </template>
      </Popup>
      <RulePopup
        ref="ruleRef"
        :ruleText="ruleContent"
        :popAttrs="rulePopAttrs"
      />
      <RecordList
        ref="recordRef"
        :fetchApi="getRecord"
        @close="disabledPull = false"
      />
    </van-pull-refresh>
  </div>
</template>

<script>
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import {
  getActivityDetail,
  onReceiveMultiGift,
  getAfterCallActRewardRecord,
  getAllActivityRule,
  getAfterCallActRoleList,
  switchRole,
} from '@/apis/qiweiMiniGame'
import RecordList from '@/components/RecordList.vue'
import Popup from '@/components/Popup.vue';
import RulePopup from '@/components/RulePopup.vue';
import qiweiShareMixin from '../qiweiShareMixin'
import store from "@/store";
import CustomSelect from '@/components/Select.vue'
import { isDef } from '@wanxin-site/common-utils'

const FEEDTYPE_MAP = {
  SUCCESS: 'SUCCESS', // 成功
  CONDITION_NOT_SATISFY: 'CONDITION_NOT_SATISFY',
  CONFIRM: 'CONFIRM', // 领取确认
  SHOW_GIFT: 'SHOW_GIFT', // 礼包展示
  MORE_GAME: 'MORE_GAME', // 更多游戏
  REACH_LIMIT: 'REACH_LIMIT', // 已达上限
  SWITCH_ROLE: 'SWITCH_ROLE', // 切换角色
}

const {
  SUCCESS, RULE, SWITCH_ROLE, CONDITION_NOT_SATISFY,
} = FEEDTYPE_MAP

const SCENE_MAP = {
  5: 2,
  6: 3,
  9: 4,
}

export default {
  name: 'QiWeiRecallMaintain',
  mixins: [trackingMixin, qiweiShareMixin],
  components: {
    RecordList,
    Popup,
    RulePopup,
    CustomSelect,
  },
  data () {
    return {
      isLoading: false,
      visible: false,
      disabledPull: false,
      activityInfo: {},
      FEEDTYPE_MAP,
      feedbackType: RULE,
      rulePopAttrs: {
        confirmButtonColor: "#FF9C47",
        skins: {
          headerBg: "#ED804B"
        },
      },
      actTime: '',
      blockInfo: [],
      ruleContent: '',
      roleInfo: {},
      roleList: [],
      selectedRoleId: '',
      showTip: false,
      receiveLoading: false,
      curGift: {},
      errorMsg: '',
      errorCode: false,
    }
  },
  created () {
    
  },
  mounted () {
    this.init()
  },
  watch: {
    visible (val) {
      if (!val) {
        this.showTip = false
        this.selectedRoleId = ''
      }
    },
  },
  computed: {
    // 必要参数
    nessaryParams () {
      return {
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.params.activityId,
        // uid: this.params.uid,
        appkey: this.params.appkey,
        type: this.activityType,
      }
    },
    trackActInfo () {
      const { name, appName, appkey } = this.activityInfo || {}
      return {
        activity_id: this.params.activityId,
        activity_name: name,
        app_name: appName,
        appkey: appkey,
        scene: SCENE_MAP[this.activityType],
      }
    },
    trackUserInfo () {
      return {
        userId: this.activityInfo.uid,
        role_id: this.activityInfo.roleId,
      }
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return {
        [RULE]: {
          title: '活动规则',
          showConfirmButton: false,
          onSure: () => {},
        },
        [SWITCH_ROLE]: {
          title: '切换角色',
          showConfirmButton: true,
          onSure: () => {
            
          },
        },
        [SUCCESS]: {
          title: '领取成功',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
        },
        [CONDITION_NOT_SATISFY]: {
          title: '不满足领取条件',
          showConfirmButton: false,
          onSure: () => {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_enterprise_promote_to_complete_button,
              this.trackActInfo,
              this.trackUserInfo,
            )
            this.goLink()
          },
        },
      }
    },
  },
  methods: {
    init (isFirst = true) {
      if (isFirst) {
        this.onGetActRule()
      }
      return this.getActivityDetailInfo().then(res => {
        if (isFirst) {
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.enterprise_wx_h5_page_underway,
            this.trackActInfo,
            this.trackUserInfo,
          )
        }
      })
    },
    onRefresh () {
      this.isLoading = true
      this.init(false).finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 400)
      })
    },
    getActivityDetailInfo () {
      const params = {
        ...this.nessaryParams,
      }
      if (isDef(this.sceneType)) {
        params.sceneType = this.sceneType
      }
      return getActivityDetail(params).then(res => {
        console.log(res)
        this.activityInfo = res.data || {}
        const { startTime, endTime, sectorVoList, roleVo } = res.data || {}
        this.roleInfo = roleVo || {}
        this.actTime = `${startTime} - ${endTime}`
        this.blockInfo = sectorVoList || []
      }).catch((err) => {
        const { code } = err
        if ([1306, 1319].includes(code)) {
          this.errorCode = code
        }
      })
    },
    onReceive (gift, block) {
      if (this.receiveLoading) return
      const { slaveId, drawStatus, giftId, drawCondition } = gift || {}
      if (drawStatus !== 0) return
      this.receiveLoading = true
      this.curGift = gift
      const { sectorId } = block || {}
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_many_gift_draw_button,
        {
          ...this.trackActInfo,
          draw_task: drawCondition,
        },
        this.trackUserInfo,
      )
      onReceiveMultiGift({
        uid: this.activityInfo.uid,
        activityId: this.params.activityId,
        slaveId: slaveId,
        type: this.activityType,
      }).then(res => {
        const { cdk } = res.data || {}
        if (cdk) {
          this.cdk = cdk
          this.triggerVisible(true, SUCCESS)
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.enterprise_wx_h5_many_gift_reward_pop,
            {
              ...this.trackActInfo,
              cdk,
              draw_task: drawCondition,
            },
            this.trackUserInfo,
          )
        } else {
          this.$toast('领取失败，请联系客服')
        }
        this.init(false)
      }).catch((err) => {
        const { code, msg } = err
        // 1315 - 多日礼包不满足累计付费
        // 1316 - 多日礼包不满足任意付费
        // 1317 - 多日礼包收到链接当日登录游戏不满足条件
        // 1318 - 多日礼包累计登录游戏X 天不满足条件
        if ([1315, 1316, 1317, 1318].includes(code)) {
          const { msg: emsg, curValue, tarValue } = JSON.parse(msg || '{}')
          this.errorMsg = emsg
          this.triggerVisible(true, CONDITION_NOT_SATISFY)
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.enterprise_wx_h5_many_gift_task_tip_pop,
            {
              ...this.trackActInfo,
              cur_value: curValue,
              tar_value: tarValue,
              draw_task: drawCondition,
            },
            this.trackUserInfo,
          )
        } else {
          this.$toast(msg)
        }
      }).finally(() => {
        setTimeout(() => {
          this.receiveLoading = false
        }, 500)
      })
    },
    onGetActRule () {
      getAllActivityRule({}).then(res => {
        const { manyRuleMap } = res.data || {}
        const typeMapType = {
          5: 1,
          6: 2,
          9: 3,
        }
        const { rule_content } = manyRuleMap[typeMapType[this.activityType]] || {}
        this.ruleContent = rule_content
      })
    },
    onGetRoleList () {
      getAfterCallActRoleList({
        activityId: this.params.activityId,
        uid: this.activityInfo.uid,
        type: this.activityType,
      }).then(res => {
        const list = res.data || []
        this.roleList = list.map(item => {
          const { role_id, role_name, server_name } = item || {}
          return {
            text: `${server_name}-${role_name}`,
            value: role_id,
          }
        })
      })
    },
    onClickChangeBind () {
      if (this.activityInfo.activityStatus === 1) return
      if (!this.validUid()) return
      this.triggerVisible(true, SWITCH_ROLE)
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_cut_role_button,
        this.trackActInfo,
        this.trackUserInfo,
      )
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_cut_role_pop,
        this.trackActInfo,
        this.trackUserInfo,
      )
      this.onGetRoleList()
    },
    onSwitchRole () {
      return switchRole({
        activityId: this.params.activityId,
        uid: this.activityInfo.uid,
        type: this.activityType,
        roleId: this.selectedRoleId,
      }).then(res => {
        this.triggerVisible(false)
        this.init(false)
      })
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },
    getRecord () {
      return getAfterCallActRewardRecord({
        activityId: this.params.activityId,
        uid: this.activityInfo.uid,
      })
    },
    // 打开奖励记录面板
    onShowRecord () {
      if (!this.validUid()) return
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_draw_info_button,
        {
          ...this.trackActInfo,
        },
        { userId: this.activityInfo.uid, role_id: this.activityInfo.roleId }
      )
      this.$refs.recordRef.triggerVisible(true)
      this.disabledPull = true
    },
    validUid () {
      if (!this.activityInfo.uid) {
        this.$toast('未查询到角色信息')
        return false
      }
      return true
    },
    onBeforeClose (action, done) {
      if (this.feedbackType === SWITCH_ROLE && action === 'confirm') {
        if (!this.selectedRoleId) {
          this.showTip = true
          done(false)
        } else {
          this.showTip = false
          const role = this.roleList.find(item => item.value === this.selectedRoleId)
          const { role_id, role_name, server_id, server_name } = role || {}
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.enterprise_wx_h5_cut_role_affirm_button,
            {
              ...this.trackActInfo,
              role_id,
              role_name,
              server_id,
              server_name,
            },
            this.trackUserInfo,
          )
          this.onSwitchRole().then(() => {
            done()
          })
        }
      } else {
        done()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.wrap {
  padding: 8px 6px;
  background-color: #320202;
  min-height: 100vh;
  .error_page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #d3d3d3;
    padding: 16px;
    .error_page_content {
      margin-top: 110px;
      font-size: 18px;
      line-height: 22px;
      color: #fff;
      background-color: #949494;
      border-radius: 8px;
      text-align: center;
      padding: 52px 32px;
    }
  }
  .header {
    padding: 12px 10px;
    background: linear-gradient(180deg,rgba(144,38,25,1.00) 0%, #c5270d 100%), #ffffff;
    border-radius: 8px;
  }
  .header_btn {
    color: #34EEFF;
    white-space: nowrap;
  }
  .main {
    min-height: calc(100vh - 100px);
  }
  .error_end {
    min-height: calc(100vh - 200px);
  }
  .block_item {
    background-color: #b23a1d;
    padding: 6px 5px 8px;
    .block_title {
      position: absolute;
      width: 100%;
      min-height: 54px;
      top: 0;
      left: 0;
      background-size: 100% 100%;
      padding: 6px 6px 18px;
    }
    .block_reward_wrap {
      background-color: #FEEFC4;
      padding: 56px 8px 20px;
    }
  }
  .block_item + .block_item {
    margin-top: 9px;
  }
  .block_reward_item {
    border-radius: 8px;
    background-color: #fff7e2;
    padding: 12px 6px 12px 8px;
    .block_reward_icon {
      width: 58px;
      height: 58px;
    }
    .block_reward_info {
      flex: 1;
      width: 0;
    }
    .block_reward_btn {
      width: 75px;
      height: 30px;
      background-color: #ea6129;
      margin-left: 6px;
    }
    .block_reward_name {
      font-size: 15px;
      color: #590200;
    }
    .block_reward_condition {
      font-size: 11px;
      color: #F55C02;
    }
    .block_reward_content {
      font-size: 11px;
      line-height: 14px;
      color: #977844;
    }
  }
}
.receive_fail_content {
  width: 100%;
  padding: 8px 16px;
  
  .receive_fail_icon {
    width: 54px;
    height: 54px;
    margin-right: 12px;
  }
  .receive_fail_desc {
    font-size: 11px;
    color: #977844;
  }
  .receive_fail_name {
    font-size: 15px;
    color: #590200;
    margin-bottom: 9px;
  }
  .receive_fail_info {
    flex: 1;
    width: 0;
  }
}
</style>
<style lang="scss">
// 维持圆角 && 不 overflow hidden
.van-dialog {
  overflow: unset !important;
  .van-dialog__header {
    border-radius: 6px;
    overflow: hidden;
  }
  .van-dialog__footer {
    border-radius: 6px;
  }
}
</style>